<template>
	<div><Button label="Click Me" class="primary" /></div>
</template>

<script setup lang="ts">
import { onMounted, PropType, ref, watch } from "vue"
import Button from "primevue/button"
const props = defineProps({
	exampleProp: {
		type: String as PropType<string>,
		required: false,
		default: "",
	},
})

const exampleBoundModelName = defineModel("exampleBoundModelName", {
	type: String,
	required: false,
})

onMounted(async () => {})
</script>

<style scoped></style>
